import type { Deck } from "."

export const getPreviousDeck = ({ deckId }: { deckId: Deck.Id }): Deck.Id => {
  if (deckId === "neck_deep") return "waist_deep"
  return "ankle_deep"
}
